const methodList = {
  trackLaunchCTA: (banner, cta = "") => {
    if (!!window.hasOwnProperty("_satellite")) {
      const getHtmlLabel = (labelEntry) => {
        const htmlElem = document.createElement("div");
        htmlElem.innerHTML = labelEntry;
        return htmlElem.innerText.trim();
      };
      (window as any)._satellite.track("DCRMBannerCTA", {
        label:
          !!banner.clickableBanner && cta === "zoneClickable"
            ? "Zone clickable"
            : getHtmlLabel(banner[cta + "Text"]),
        placement: banner.location,
        campaign: banner.messageId,
      });
    }
  },

  onCtaClick: (banner, cta) => {
    if (banner[`${cta}URL`] === "https://cookieconsent") {
      return;
    }
    if (banner[`${cta}Webcallback`]) {
      return;
    }
    if (!!banner[`${cta}Reponse`]) {
      if (/(accepted|refused)$/i.test(banner[`${cta}Reponse`])) {
        banner.celebrusHelper[banner[`${cta}Reponse`]]();
      } else {
        banner.celebrusHelper.custom(banner[`${cta}Reponse`]);
      }
    }

    // Envoi du formulaire
    const target = (event?.target as Element)?.matches("button")
      ? (event?.target as HTMLFormElement)
      : (event?.target as HTMLFormElement).closest("button");
    const form = (target as Element).closest("form");

    form?.setAttribute("target", target.getAttribute("formtarget"));
    form?.setAttribute("action", target.getAttribute("formaction"));
    form?.setAttribute("method", target.getAttribute("formmethod"));
    console.log(`${cta}KeepBanner`, banner[`${cta}KeepBanner`])
    if (banner[`${cta}KeepBanner`] === "false") {
      methodList.getEmptyBanner(banner);
    } else {
      form?.submit();
    }
  },

  onCloseClick: (banner) => {
    if (!!banner.crossAnswer) {
      if (/(refused|accepted)$/i.test(banner.crossAnswer)) {
        banner.celebrusHelper[banner.crossAnswer]();
      } else {
        banner.celebrusHelper.custom(banner.crossAnswer);
      }
    } else {
      banner.celebrusHelper.refused();
    }
    console.log(banner.location, "close");
    methodList.getEmptyBanner(banner);
  },

  getEmptyBanner: (banner) => {
    console.log(banner.location)
    window.dispatchEvent(
      new CustomEvent(`rtim-banner:${methodList.convertBannerLocationToEventName(banner.location)}`, {
        detail: {
          content: {
            emplacement: banner.location,
            nom_gabarit: "Gab20",
          },
          placement: {
            id: banner.location,
            size: "1260x630",
            zone: "udc-top",
          },
        },
      })
    );
  },

  convertBannerLocationToEventName: (location) =>
    !!location.startsWith("banner-")
      ? location.replace("banner-", "")
      : location,
};

export default methodList;
